import { em } from 'polished'
import styled from 'styled-components'

import TrustpilotReviews from 'components/_special/TrustpilotReviews'

export const SecondBlock = styled.div`
  padding-bottom: ${em(40)};
`

export const ThirdBlock = styled.div`
  padding-bottom: ${em(20)};

  ${p => p.theme.mq.upMd} {
    padding-bottom: 0;
  }
`

export const FaqWrapper = styled.div`
  padding-top: ${em(20)};

  ${p => p.theme.mq.upMd} {
    padding-top: ${em(40)};
  }
`

export const TrustpilotReviewsStyled = styled(TrustpilotReviews)`
  ${p => p.theme.mq.upMd} {
    padding-bottom: 0 !important;
  }
`
